import { render, staticRenderFns } from "./ownership_breakdown.vue?vue&type=template&id=31c6ce75&"
import script from "./ownership_breakdown.vue?vue&type=script&lang=js&"
export * from "./ownership_breakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports